module.exports = __webpack_public_path__ + "static/media/app_developer.61f72840.svg";